'use client'

import EastIcon from '@mui/icons-material/East'
import { Container, Grid, Link, styled } from '@mui/material'

import { useTranslations } from '@/hooks/useTranslations'
import { colors } from '@/themes/commerce/colors'

import type { FC, PropsWithChildren } from 'react'
import type { AnnouncementBar } from '@/gen/sanity/schema'

const AnnouncementBarWrapper = styled(Grid)(({ theme }) => ({
  paddingBlock: theme.spacing(2),
  color: theme.palette.text.primary,
}))

interface AnnouncementBarProps extends PropsWithChildren {
  announcementBar: AnnouncementBar
}

export const AnnouncementBarContainer: FC<AnnouncementBarProps> = ({ announcementBar }) => {
  const { language } = useTranslations()

  const sxBackgroundColor = {
    backgroundColor: announcementBar.backgroundColor
      ? announcementBar.backgroundColor.hex
      : colors.background.component.ctaInverseHover,
  }

  return (
    <AnnouncementBarWrapper sx={{ ...sxBackgroundColor }}>
      <Container>
        <Grid container>
          {announcementBar.textLine1 ? announcementBar.textLine1[language] : ''}
          {announcementBar.textLine2 ? announcementBar.textLine2[language] : ''}
          {announcementBar.linkUrl && announcementBar.linkText && (
            <Link
              href={announcementBar.linkUrl}
              color={announcementBar.linkColor ? announcementBar.linkColor.hex : 'inherit'}
              sx={{
                textDecoration: 'none',
                fontWeight: 700,
                display: 'flex',
                gap: 1,
                alignItems: 'center',
                marginLeft: 2,
              }}
            >
              {announcementBar.linkText[language]}
              <EastIcon fontSize="small" />
            </Link>
          )}
        </Grid>
      </Container>
    </AnnouncementBarWrapper>
  )
}
